import { Avatar, Paper, Stack, Typography } from '@mui/material';
import { ControlledRadioButtons } from 'Components';
import { ControlledRadioButtonsPurple } from 'Components/ControlledRadioButtonsPurple';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleAlert } from 'Images';
import { OrderRegularMedicationsContext } from 'Modules/MedicationsAndPrescriptionsLobby/OrderRegularMedicationsContext';
import { useContext } from 'react';

export const OrderPeriod = () => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );
  const isDesktop = useIsDesktop();
  const { period, setPeriod, setIsSplit } = useContext(
    OrderRegularMedicationsContext
  );
  return (
    <Stack
      sx={{
        mt: 5,
      }}
    >
      <Typography variant='h5'>{dictionary.createOrder.orderPeiod}</Typography>
      <Typography variant='body3'>
        {dictionary.createOrder.orderPeriodInfo}
      </Typography>
      <ControlledRadioButtonsPurple
        title=''
        isDirectionRow
        radioGroupSx={{ gap: '5px', mb: isDesktop ? 4 : 1 }}
        values={[
          dictionary.createOrder.oneMonth,
          dictionary.createOrder.threeMonths,
        ]}
        onChange={(value: string) =>
          setPeriod(value === dictionary.createOrder.threeMonths ? 3 : 1)
        }
        value={
          period === 3
            ? dictionary.createOrder.threeMonths
            : dictionary.createOrder.oneMonth
        }
      />
      {period === 3 && (
        <>
          <Typography>{dictionary.createOrder.isSplitOrder}</Typography>
          <ControlledRadioButtons
            isDirectionRow
            title=''
            values={[
              dictionary.createOrder.split,
              dictionary.createOrder.supplyAll,
            ]}
            onChange={(value: string) =>
              setIsSplit(value === dictionary.createOrder.split)
            }
            radioGroupSx={{ gap: isDesktop ? '5px' : '0px', mb: 2 }}
            valueSx={{
              '& .MuiTypography-root': {
                fontWeight: 400,
              },
              '&.MuiFormControlLabel-root': {
                ml: 0,
              },
              mb: isDesktop ? 3 : 2,
            }}
          />
          <Paper
            elevation={0}
            sx={{
              border: '1px solid',
              borderColor: 'primary.shade_200',
              bgcolor: 'primary.shade_100',
              borderRadius: '12px',
              p: '24px',
              width: 'fit-content',
              mb: 2,
            }}
          >
            <Stack
              direction='row'
              sx={{
                alignItems: 'center',
                columnGap: '8px',
              }}
            >
              <Avatar
                sx={{ height: '24px', width: '24px' }}
                src={PurpleAlert}
                alt=''
              />
              <Typography component='h3' variant='body3'>
                {dictionary.createOrder.longPeriodNote}
              </Typography>
            </Stack>
          </Paper>
        </>
      )}
    </Stack>
  );
};
